export default function PricingPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-900">Tarifs</h1>
      <p className="mt-4 text-gray-600">Free QR Code est gratuit. Les fonctionnalités avancées resteront accessibles sans frais.</p>
    </div>
  );
}
